import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
export var ErrorUtils = /*#__PURE__*/function () {
  function ErrorUtils() {
    _classCallCheck(this, ErrorUtils);
  }
  return _createClass(ErrorUtils, null, [{
    key: "extractErrorMessage",
    value: function extractErrorMessage(error) {
      if (error instanceof Error) {
        return ErrorUtils.redactSensitiveInfo(error.message || 'unknown-error');
      } else {
        return ErrorUtils.redactSensitiveInfo(String(error));
      }
    }
  }]);
}();
_defineProperty(ErrorUtils, "redactSensitiveInfo", function (str) {
  var redacted = str
  // Ignored via go/ees005
  // eslint-disable-next-line require-unicode-regexp
  .replace(/[^,\s]+\@[^,\s]+/g, '[REDACTED EMAIL]')
  // Ignored via go/ees005
  // eslint-disable-next-line require-unicode-regexp
  .replace(/[^,\s]+\.[^,\s]+/g, '[REDACTED URL]');
  return redacted;
});